import styled from "styled-components";
import colors from "../../../../../styles/colorPalette";
import shades from "../../../../../styles/shadesPalette";
import { fadeIn } from "../../../../../styles/animations";

export const TableInstance = styled.table`
  width: 1300px;
  height: 320px;
  border-spacing: 0;
  box-sizing: border-box;
  background: transparent;
  overflow: hidden;
  box-shadow: ${shades.shadow3};
  @media (max-width: 1400px) {
    width: 1087px;
    height: 320px;
  }
`;

export const THead = styled.thead`
  position: sticky;
  align-items: center;
  height: 82px;
  text-align: center;
  background: white;
`;

export const TRHead = styled.tr`
  font-size: 10px;
  text-align: left;
  color: ${colors.gray3};
  box-sizing: border-box;
  & > * {
    max-width: 90px;
    &:nth-child(1) {
      display: none;
    }
    &:nth-child(2) {
      max-width: 870px;
    }
  }
`;

export const THHead = styled.th`
  position: sticky;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-y: auto;
  background: transparent;
`;

export const Scroll = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 100%;
  height: 188px;
  color: #1e1e1e;
  overflow-x: hidden;
  scrollbar-gutter: stable;
  background: ${colors.white1};
  &::-webkit-scrollbar {
    background: ${colors.white1};
    width: 0.5em;
    height: 0.5em;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${colors.grayScroll};
    border-radius: 4px;
  }
  @media (max-width: 1366px) {
    width: 1087px;
    height: 188px;
  }
`;

export const TBody = styled.tbody`
  width: 100%;
  height: 100%;
  color: #1e1e1e;
  background: transparent;
`;

export const TRBody = styled.tr`
  align-items: center;
  font-size: 14.5px;
  color: #1e1e1e;
  &:hover {
    background: #edf2f7;
  }
`;

export const TDBody = styled.td`
  white-space: nowrap;
  color: #1e1e1e;
  text-overflow: ellipsis;
`;

export const TR = styled.tr`
  height: 50px;
  color: #1e1e1e;
  border-bottom: 1px solid ${colors.gray2};
  text-align: center;
  vertical-align: bottom;
  overflow: hidden;
  animation: 1s ${fadeIn} forwards;
  &:hover {
    background: #edf2f7;
  }
  & > * {
    max-width: 90px;
    height: 300px;
    &:nth-child(1) {
      display: none;
    }
    &:nth-child(2) {
      max-width: 870px;
    }
  }
  @media (max-width: 1366px) {
    & > * {
      &:nth-child(2) {
        max-width: 470px;
      }
    }
  }
`;

export const TD = styled.td`
  height: 50px;
`;

export const TDSub = styled.td`
  height: 50px;
`;

export const Span = styled.span`
  height: 2px;
`;

export const Text = styled.div`
  margin-left: 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Column = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-family: "OpenSansRegular";
  font-size: 18px;
  font-weight: 400;
  color: ${colors.gray6};
  @media (max-width: 1400px) {
    //width: 90px;
    font-size: 18px;
  }
`;

export const Cell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-family: "OpenSansRegular";
  font-size: 18px;
  font-weight: 400;
  color: #3e3d3f;
  background: transparent;
  @media (max-width: 1366px) {
    font-size: 14px;
  }
`;
